// extracted by mini-css-extract-plugin
module.exports = {"pageLoading":"LoadingPage_pageLoading__36pzF","spinner":"LoadingPage_spinner__2bw4k","spinner-animation":"LoadingPage_spinner-animation__2FslB"};